






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticProject } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticProject
  },
  mixins: [RenderMenuMixin]
})

/**
 * 总览-明细
 */
export default class ProjectAll extends Vue {

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="project"></acgn-statics-menu>
    );
  }
}
